import { Component } from "react";
import {set_datapage, SetLanguage, getLanguage} from 'redux/actions/DataPageAction'
import { connect } from "react-redux";
import { createHChart } from "layouts/mainsection/components/CHighchartToolsTraffic";

class MOMetoTranspTrafEspecies extends Component {
 
  componentDidMount () {
  
    
  }
  render () {
    
    return this.props.data.length > 0 ?  <> {createHChart('PhartMOMetoTranspTrafEspecies',
    {
      chart: { type: 'pie' },
      title: { text: this.props.title },
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                  enabled: true,
                  format: '{point.name} {point.percentage:.2f}%',
                  // filter: {
                  //   property: 'percentage',
                  //   operator: '<',
                  //   value: 14
                  // }
                  
                  // distance: -50,
              },
              showInLegend: false
          }
      },
      series: [{
          name: 'Cantidad',
          colorByPoint: true,
          data: this.props.data.map(item => ({name: item.metodo, y: +item.cantidad}))
      }]
    }
    )} 
    <div style={{fontSize: '0.9em'}}>

      <div className="has-text-centered" style={{fontSize: '0.9em'}}>
        <p className="px-6" style={{
        color: '#000',
        fontSize: '1.1em',
        
        fill: '#000'
        }}><i>{ this.props.description }</i></p>
      </div>
      </div>
      </>
    : null
    
  }
}

export default connect(getLanguage, {set_datapage, SetLanguage})(MOMetoTranspTrafEspecies)